export default "__VITE_ASSET__DRkCVsmf__"